import React, { useState, useEffect } from "react";
import shortid from "shortid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const CategoryInfo = (props) => {
  const [showLess, setShowLess] = useState(true);
  const [shouldShowMoreLessButtonVisible, setShouldShowMoreLessButtonVisible] =
    useState(false);

  useEffect(() => {
    let maxLineLength = 49;

    let sortedArray = props.vendorProfile.categories;

    let categoriesArray = sortedArray.map((obj) => obj.name);
    let identified_lines = countLines(categoriesArray, maxLineLength);

    if (identified_lines > 2) {
      setShouldShowMoreLessButtonVisible(true);
    }
  }, [props?.vendorProfile?.categories]);

  function countLines(arr, maxLineLength) {
    let lineCount = 0;
    let currentLine = "";

    arr.forEach((item, index) => {
      // If the item itself exceeds maxLineLength, count it as a separate line

      if (item.length > maxLineLength) {
        // Count the current line if it has content
        if (currentLine.length > 0) {
          lineCount++;
          currentLine = "";
        }
        lineCount++;
      } else {
        // Add a space before the item if it's not the first item in the line
        let space = currentLine.length > 0 ? " " : "";

        // Check if the current line plus the new item exceeds the max line length

        if ((currentLine + space + item).length <= maxLineLength) {
          currentLine += space + item;
        } else {
          lineCount++;
          currentLine = item;
        }
      }
    });

    // Count the last line if it has content
    if (currentLine.length > 0) {
      lineCount++;
    }

    return lineCount;
  }

  return (
    <React.Fragment>
      <div className="category_txt">
        <span className="txt">Category:</span>
      </div>
      <div className="category_list_block">
        <ul className={showLess ? "list_category" : "list_category clear"}>
          {props.vendorProfile.categories.length > 0
            ? props.vendorProfile.categories.map((obj) => (
                <li key={`uniq_key_${obj.link}`}>
                  <Link to={obj.link}>{obj.name}</Link>
                </li>
              ))
            : "Not Available"}
        </ul>
        {shouldShowMoreLessButtonVisible && (
          <a
            href="#"
            class="showLessMoreContent"
            onClick={(e) => {
              e.preventDefault();
              setShowLess(!showLess);
            }}
          >
            {showLess ? `Show more` : `Show less`}
          </a>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorProfile: state.vendorProfile,
  };
};

export default connect(mapStateToProps)(CategoryInfo);
